import './EditAddress.scss';
import Component from './EditAddress.js';
export default Component;
